/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  FarAwayMoveIn info component
 */

import { Close } from '@zcode-ui/icons'
import { cn } from '@zcode-ui/shadz-ui'
import React, { useState } from 'react'
import phoneIcon from '../../../../../img/icons/phoneIcon.svg'
import css from './FarAwayMoveIn.module.scss'

export const FAR_AWAY_MOVE_IN_THRESHOLD = 75

export interface FarAwayMoveInProps {
  isMobile: boolean
  onPhoneClick: () => void
  phoneHref: string | null | undefined
}

export const FarAwayMoveIn = ({ isMobile, onPhoneClick, phoneHref }: FarAwayMoveInProps) => {
  const [hide, setHide] = useState(false)

  if (hide) {
    return null
  }

  const onClose = () => {
    setHide(true)
  }

  return (
    <div className={css.FarAwayMoveIn}>
      <div className={css.headerline}>
        <div className={css.title}>Just browsing?</div>
        <button
          aria-label="close recommendation"
          type="button"
          className={cn(
            'bg-transparent',
            'border-0',
            'p-0',
            'rounded-[3px]',
            'select-none',
            'cursor-pointer',
            'touch-manipulation',
            'active:bg-[#f3f5f6]',
            'active:shadow-[0_1px_0_0_#f0f2f3,inset_0_2px_2px_0_#e6e8e9]',
            'active:outline-0',
            'hover:text-[#333]',
            'hover:no-underline',
            'focus:text-[#333]',
            'focus:no-underline',
            'focus:outline-none'
          )}
          onClick={onClose}
        >
          <Close />
        </button>
      </div>
      <p className={css.text}>
        Looks like your move-in date is a few months away. We recommend calling the property instead
        to ask about future availability.
      </p>
      {isMobile && phoneHref && (
        <div>
          <a
            className={cn(
              'bg-gray-0',
              'shadow-[0_1px_2px_0_rgba(0,0,0,0.1)]',
              'select-none',
              'inline-block',
              'mb-0',
              'font-[Moderat]',
              'whitespace-nowrap',
              'text-center',
              'align-middle',
              'cursor-pointer',
              'touch-manipulation',
              'active:bg-[#f3f5f6]',
              'active:shadow-[0_1px_0_0_#f0f2f3,inset_0_2px_2px_0_#e6e8e9]',
              'active:outline-0',
              'hover:text-[#333]',
              'hover:no-underline',
              'focus:text-[#333]',
              'focus:no-underline',
              'focus:outline-none',
              css.phoneBtn
            )}
            href={phoneHref}
            onClick={onPhoneClick}
          >
            <img
              alt=""
              className={css.callNowIcon}
              height="15"
              loading="lazy"
              src={phoneIcon}
              width="21"
            />
            <span className={css.callText}>Call</span>
          </a>
        </div>
      )}
    </div>
  )
}
